import React, { useContext } from "react";
import { InfoContext, Match } from "../../InfoContext";
import { AuthContext } from "../../AuthContext";
import { DashboardContext } from "../DashboardContext";
import { UserContext } from "../../UserContext";
import MatchCard from "../Matches/components/MatchCard";

// GroupMatchesCard-Komponente
interface GroupMatchesCardProps {
  groupName: string;
  matches: Match[];
  for_ref?: boolean;
}

const GroupMatchesCard: React.FC<GroupMatchesCardProps> = ({
  groupName,
  matches,
  for_ref = false,
}) => {
  const { role } = useContext(AuthContext);
  const { myTeam } = useContext(DashboardContext);
  const { user } = useContext(UserContext);
  const { getTeamById } = useContext(InfoContext);

  let own_team_id = -1;

  if (role === "CAPTAIN" || role === "CAPTAIN_PENDING") {
    if (myTeam) {
      own_team_id = myTeam.team_id;
      if (
        !matches.some(
          (match) =>
            match.home_id === myTeam.team_id ||
            match.guest_id === myTeam.team_id ||
            match.referee_team_id === myTeam.team_id ||
            match.referee_team_id_2 === myTeam.team_id
        )
      ) {
        return null;
      }
    } else {
      return null;
    }
  }

  if (role === "PLAYER") {
    const team =
      user?.member_of !== undefined && user?.member_of !== null
        ? getTeamById(user.member_of)
        : undefined;
    if (team) {
      own_team_id = team.team_id;
      if (
        !matches.some(
          (match) =>
            match.home_id === team.team_id ||
            match.guest_id === team.team_id ||
            match.referee_team_id === team.team_id ||
            match.referee_team_id_2 === team.team_id
        )
      ) {
        return null;
      }
    } else {
      return null;
    }
  }

  const matchesByWeek = matches.reduce<Record<string, Match[]>>(
    (acc, match) => {
      const week = match.week.toString();
      acc[week] = acc[week] || [];
      acc[week].push(match);
      return acc;
    },
    {}
  );

  const sortedWeeks = Object.entries(matchesByWeek).sort(
    (a, b) => parseInt(a[0], 10) - parseInt(b[0], 10)
  );

  return (
    <div className="bg-white/10 rounded-xl p-4 w-full">
      <h3 className="text-2xl font-bold mb-2">Matches {groupName}</h3>
      {sortedWeeks.map(([week, weekMatches]) => (
        <div key={week} className="p-2 mb-4 border-b last-of-type:border-b-0">
          <h2 className="text-2xl mt-3 font-bold">Week {week}</h2>
          {weekMatches
            .filter(
              (a) =>
                a.guest_id === own_team_id ||
                a.home_id === own_team_id ||
                a.referee_team_id === own_team_id ||
                a.referee_team_id_2 === own_team_id ||
                role === "ADMIN"
            )
            .sort((m1, m2) => m2.id - m1.id)
            .map((match) => (
              <div
                key={`${match.id}-${match.home_id}-${match.guest_id}`}
                className="border-b last-of-type:border-b-0 border-white/30"
              >
                <MatchCard
                  match={match}
                  own_team_id={own_team_id}
                  is_ref={match.referee_team_id === own_team_id}
                  is_ref2={match.referee_team_id_2 === own_team_id}
                  for_ref={for_ref}
                />
              </div>
            ))}
        </div>
      ))}
    </div>
  );
};

export default GroupMatchesCard;
